import { candidateAPI } from "../api/candidate";
import { useLatestQuery } from "../api/useLatestQuery";
import { useWhoAmI } from "./useWhoAmI";

export function useConsentsForCandidate() {
  const { whoAmI, selectedVerifiedProfileInConcernForThisSession } = useWhoAmI();

  const { data: consentsForCandidates, isFetched: isConsentFetched } =
    useLatestQuery(
      ["candidateAPI.quickConsentCheckForCandidate"],
      () => candidateAPI.quickConsentCheckForCandidate({}),
      { enabled: !!selectedVerifiedProfileInConcernForThisSession }
    );

  // The «Vi mangler ditt samtykke» banner (MissingConsentMessage) counts every
  // konsern samtykke type the candidate has not answered, on purpose. The
  // onboarding popup asks only for type 5000, because the portal must not be
  // used without that one; the candidate answers the rest under Profil →
  // Personvern → Samtykker, and the banner is what tells them the rest exist.
  // Do not scope this to type 5000: PR #812 did, and it was declined on #774.
  const notActiveConsents =
    consentsForCandidates?.items?.filter((consent) => !consent.active) || [];

  // I need to find consent with type 5000 and check if it is active or if consented = false
  const hasMissing5000Consent = !!consentsForCandidates?.items?.find(
    (consent) =>
      consent.consentType === 5000 && (!consent.active || !consent.consented)
  );

  const consentsWithout5000 = consentsForCandidates?.items?.filter(
    (consent) => consent.consentType !== 5000
  );

  const consent5000 = consentsForCandidates?.items?.find(
    (consent) => consent.consentType === 5000
  );

  if (!whoAmI?.nVerifiedProfilesInConcern)
    return {
      consentsForCandidates: null,
      notActiveConsents: [],
      isConsentFetched: false,
      hasMissing5000Consent: false,
      consentsWithout5000: [],
      consent5000: null,
    };
  if (!isConsentFetched)
    return {
      consentsForCandidates: null,
      notActiveConsents: [],
      isConsentFetched: false,
      hasMissing5000Consent: false,
      consentsWithout5000: [],
      consent5000: null,
    };

  return {
    consentsForCandidates,
    consentsWithout5000,
    notActiveConsents,
    hasMissing5000Consent,
    isConsentFetched,
    consent5000,
  };
}
